import React from 'react';
import './textEditorButton.styles.scss';
import Button, {ButtonSizeType} from '../button/Button';

interface TextEditorButtonProps {
    icon: string;
    onClick: () => void;
    isActive?: boolean;
    size?: ButtonSizeType;
    className?: string;
    ariaLabel?: string;
}

function TextEditorButton({icon, onClick, isActive, size = 'sm', className, ariaLabel}: TextEditorButtonProps): JSX.Element {
    return (
        <Button
            leading={icon}
            size={size}
            square
            className={className}
            variant={isActive ? 'soft' : 'ghost'}
            color={isActive ? 'secondary' : 'primary'}
            onClick={onClick}
            aria-label={ariaLabel}
            aria-pressed={isActive}
            title={ariaLabel}
        />
    );
}

export default TextEditorButton;
